import { useReglages } from '../../api/reglages.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import {
  CLE_CORPS_METIER,
  METIERS_SOUMISSION,
  basculeMetier,
  lireReglageMetier,
} from '../../lib/soumission';
import { _inp } from '../../components/ui/Inputs.jsx';
import { C } from '../../theme/palette';
import { pastille } from './styles';

/**
 * Réglage « Corps de métier » : ce que l'application remplira dans une
 * soumission. Entreprise générale, ou un ou plusieurs métiers cochés, ou un
 * métier écrit en toutes lettres. Le réglage vit dans les paramètres de la
 * société : il vaut pour tous ses comptes, et le serveur le relit à l'import.
 *
 * @returns {import('react').ReactElement} la carte
 */
export function CorpsMetierCard() {
  const { reglageJson, setReglageJson } = useReglages();
  const reglage = lireReglageMetier(reglageJson(CLE_CORPS_METIER, null));
  const enregistre = (r) => setReglageJson(CLE_CORPS_METIER, r);

  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar
        icon="🧰"
        title="Mon corps de métier"
        color={C.navy}
        sub="Ce que l’app remplira dans une soumission"
      />
      <div style={{ padding: 13 }}>
        <div
          role="switch"
          tabIndex={0}
          aria-checked={reglage.generale}
          aria-label="Entreprise générale (tout)"
          onClick={() => enregistre({ ...reglage, generale: !reglage.generale })}
          onKeyDown={(e) => {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              enregistre({ ...reglage, generale: !reglage.generale });
            }
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            background: C.navyXL,
            borderRadius: 11,
            padding: '11px 13px',
            marginBottom: reglage.generale ? 0 : 11,
          }}
        >
          <div style={{ fontSize: 11.5, fontWeight: 800, color: C.ink }}>
            🏢 Entreprise générale (tout le dossier)
          </div>
          <div
            style={{
              width: 44,
              height: 24,
              borderRadius: 999,
              background: reglage.generale ? C.green : C.border,
              position: 'relative',
              flexShrink: 0,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 3,
                left: reglage.generale ? 23 : 3,
                width: 18,
                height: 18,
                borderRadius: 999,
                background: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,.25)',
              }}
            />
          </div>
        </div>
        {!reglage.generale && (
          <>
            <div
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: C.muted,
                margin: '2px 0 8px',
                textTransform: 'uppercase',
                letterSpacing: '.3px',
              }}
            >
              Coche ton (tes) métier(s)
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {METIERS_SOUMISSION.map(([cle, nom]) => {
                const coche = reglage.metiers.includes(cle);
                return (
                  <button
                    key={cle}
                    type="button"
                    aria-pressed={coche}
                    onClick={() => enregistre(basculeMetier(reglage, cle))}
                    style={pastille(coche)}
                  >
                    {coche ? '✓ ' : ''}
                    {nom}
                  </button>
                );
              })}
            </div>
            <label
              style={{
                display: 'block',
                // Comme le champ `Inp` de la maquette : 10 px dessus et dessous.
                marginTop: 10,
                marginBottom: 10,
                fontSize: 9,
                fontWeight: 700,
                color: C.muted,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
              }}
            >
              Autre métier (si absent de la liste)
              <input
                value={reglage.autre}
                onChange={(e) => enregistre({ ...reglage, autre: e.target.value })}
                placeholder="Ex. poêlier-fumiste"
                aria-label="Autre métier"
                style={{
                  ..._inp,
                  display: 'block',
                  boxSizing: 'border-box',
                  marginTop: 3,
                  textTransform: 'none',
                  letterSpacing: 'normal',
                }}
              />
            </label>
          </>
        )}
      </div>
    </Card>
  );
}
